import { Provider } from '@angular/core';

import { WithholdingRepositoryImpl } from '@app/data/repositories/ptrab/withholding/withholding.repository';
import { WITHHOLDING_REPOSITORY } from '@app/domain/repositories/ptrab/withholding/withholding.repository.contract';

export const withholdingRepositoryProvider: Provider = {
  provide: WITHHOLDING_REPOSITORY,
  useClass: WithholdingRepositoryImpl
};
